import { render, staticRenderFns } from "./Community.vue?vue&type=template&id=4381190f&scoped=true&"
import script from "./Community.vue?vue&type=script&lang=ts&"
export * from "./Community.vue?vue&type=script&lang=ts&"
import style0 from "./Community.vue?vue&type=style&index=0&id=4381190f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4381190f",
  null
  
)

export default component.exports